/**
 * @file 工具列表
 * @author FengGuang(fengguang01@baidu.com)
 */

import React from 'react';

import TextCardGroup from '../../../../components/text-card/TextCardGroup';
import {ITextCard} from '../../../../components/text-card/TextCard';

interface IProps {
    toolList: ITextCard[]
}

const ToolList: React.FC<IProps> = props => {
    const toolList = props.toolList;

    return (
        <TextCardGroup
            className="paddle-tool-list"
            option={toolList}
            cols={3}
        />
    );
};

export default ToolList;
